package com.appsyde.shared.helper

/**
 * Calcule le titre de résolution affiché au-dessus de l'action recommandée (Copilote).
 * Recalculé côté front à chaque mise à jour d'état (intent + detected).
 *
 * Aligné avec les intents de [intentLabelFr] / TicketCardHelper et avec
 * les préférences remboursement (refund_preference) du state.
 */
object ResolutionTitleComputer {

    fun compute(intent: String?, detected: Map<String, String>): String {
        val intentNorm = intent?.trim()?.lowercase()?.replace(" ", "_") ?: return "Traitement"
        val detectedNorm = detected.mapKeys { it.key.trim().lowercase() }
        val refundPreference = detectedNorm["refund_preference"]?.trim()?.lowercase()

        return when (intentNorm) {

            // — Produit endommagé (et alias product_damaged)
            "damaged_product", "product_damaged" -> when (refundPreference) {
                "refund" -> "Remboursement"
                "replacement", "exchange" -> "Échange"
                "store_credit" -> "Avoir"
                else -> "Choix de solution"
            }

            // — Article manquant
            "missing_item" -> when (refundPreference) {
                "refund" -> "Remboursement"
                "replacement", "exchange" -> "Réexpédition"
                "store_credit" -> "Avoir"
                else -> "Choix de solution"
            }

            // — Mauvais article
            "wrong_item" -> when (refundPreference) {
                "refund" -> "Remboursement"
                "replacement", "exchange" -> "Échange"
                "store_credit" -> "Avoir"
                else -> "Choix de solution"
            }

            // — Demande de remboursement directe
            "refund_request" -> "Remboursement"

            // — Retour / Remplacement (legacy ecom)
            "return_request" -> when (refundPreference) {
                "refund" -> "Remboursement"
                "replacement", "exchange" -> "Échange"
                "store_credit" -> "Avoir"
                else -> "Retour"
            }
            "replacement_request" -> when (refundPreference) {
                "refund" -> "Remboursement"
                "replacement", "exchange" -> "Échange"
                "store_credit" -> "Avoir"
                else -> "Remplacement"
            }

            // — Annulation
            "cancellation" -> "Annulation"

            // — Suivi de commande / livraison
            "order_tracking" -> "Suivi livraison"
            "delivery_issue" -> "Problème livraison"
            "tracking_request" -> "Suivi livraison"

            // — Facturation / paiement / résiliation
            "billing_question" -> if (refundPreference == "refund") "Remboursement" else "Vérification paiement"
            "invoice_question" -> if (refundPreference == "refund") "Remboursement" else "Facturation"
            "payment_issue" -> if (refundPreference == "refund") "Remboursement" else "Paiement"
            "subscription_cancel" -> "Résiliation"

            // — Compte
            "password_reset" -> "Réinitialisation accès"
            "account_locked" -> "Déblocage compte"
            "email_change" -> "Changement d'email"

            // — Bug / produit / général
            "bug_report" -> "Analyse incident"
            "product_question" -> "Information produit"
            "general_question" -> "Assistance"

            else -> "Traitement"
        }
    }
}
